import React from 'react';

const variants = {
  success: 'bg-success-bg text-success-foreground border-success-border',
  warning: 'bg-warning-bg text-warning-foreground border-warning-border',
  danger: 'bg-danger-bg text-danger-foreground border-danger-border',
  info: 'bg-info-bg text-info-foreground border-info-border',
  neutral: 'bg-prodia-background text-prodia-text-secondary border-prodia-border',
  primary: 'bg-prodia-primary-subtle text-prodia-primary border-amber-200',
};

const icons = {
  success: 'fas fa-check-circle',
  warning: 'fas fa-exclamation-triangle',
  danger: 'fas fa-times-circle',
  info: 'fas fa-info-circle',
  neutral: 'fas fa-minus-circle',
  primary: 'fas fa-circle',
};

export function Badge({ variant = 'neutral', children, icon, showIcon = false, className = '' }) {
  const iconClass = icon || (showIcon ? icons[variant] : null);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant] || variants.neutral} ${className}`}
    >
      {iconClass && <i className={`${iconClass} text-[10px]`} aria-hidden="true" />}
      {children}
    </span>
  );
}

/** ビジネスラベル → semantic variant */
export function badgeVariantForLabel(label) {
  if (!label) return 'neutral';
  const s = String(label);
  if (/成約|稼働中|アサイン済|合格|アポ取|active|pass|hired/i.test(s)) return 'success';
  if (/待機|保留|回答待|折り返し|pending|warning|至急|urgent|high/i.test(s)) return 'warning';
  if (/見送|不合格|お断り|削除|fail|rejected|lost|ended/i.test(s)) return 'danger';
  if (/予定|面談|scheduled|info|planned|upcoming/i.test(s)) return 'info';
  return 'neutral';
}

export default Badge;
